function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.9987 4.66675C8.36689 4.66675 8.66536 4.36827 8.66536 4.00008C8.66536 3.63189 8.36689 3.33341 7.9987 3.33341C7.63051 3.33341 7.33203 3.63189 7.33203 4.00008C7.33203 4.36827 7.63051 4.66675 7.9987 4.66675Z",
  stroke: "#707274",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.9987 8.66675C8.36689 8.66675 8.66536 8.36827 8.66536 8.00008C8.66536 7.63189 8.36689 7.33341 7.9987 7.33341C7.63051 7.33341 7.33203 7.63189 7.33203 8.00008C7.33203 8.36827 7.63051 8.66675 7.9987 8.66675Z",
  stroke: "#707274",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.9987 12.6667C8.36689 12.6667 8.66536 12.3683 8.66536 12.0001C8.66536 11.6319 8.36689 11.3334 7.9987 11.3334C7.63051 11.3334 7.33203 11.6319 7.33203 12.0001C7.33203 12.3683 7.63051 12.6667 7.9987 12.6667Z",
  stroke: "#707274",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgGreyMenuDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMenuDots);
export default __webpack_public_path__ + "static/media/GreyMenuDots.2cf9d79a.svg";
export { ForwardRef as ReactComponent };